import { MAPS, type GameState, type SpaceId } from '@cc/shared';
import { CoinSVG } from './CoinSVG';
import { Button } from './Button';
import { Modal } from './Modal';

export function StackInspector({ state, spaceId, onClose }: { state: GameState; spaceId: SpaceId; onClose: () => void }) {
  const space = MAPS[state.mapId].spaces.find((item) => item.id === spaceId)!;
  return <Modal title={space.name} onClose={onClose}><p className="muted">Stack shown top to bottom.</p><div className="stack-list">{[...state.board[spaceId]].reverse().map((coin, index) => <div key={coin.uid}><CoinSVG rank={coin.rank} side={coin.side} size={40} /><strong>{index === 0 ? 'Top · ' : ''}Rank {coin.rank}</strong><span>{coin.side}</span></div>)}</div><Button variant="secondary" block onClick={onClose}>Close</Button></Modal>;
}
